// extracted by mini-css-extract-plugin
module.exports = {"main":"FlexibleImage_main__JgSjY","cover":"FlexibleImage_cover__Rwpk2","contain":"FlexibleImage_contain__qzYWV","full-size":"FlexibleImage_full-size__IcgkD"};